import { render, staticRenderFns } from "./SpaceTreeShow.vue?vue&type=template&id=166e4c02&scoped=true&"
import script from "./SpaceTreeShow.vue?vue&type=script&lang=js&"
export * from "./SpaceTreeShow.vue?vue&type=script&lang=js&"
import style0 from "./SpaceTreeShow.vue?vue&type=style&index=0&id=166e4c02&prod&lang=css&"
import style1 from "./SpaceTreeShow.vue?vue&type=style&index=1&id=166e4c02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166e4c02",
  null
  
)

export default component.exports